import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { VIEW_BOOKING } from "../../../../services/ApiCalls";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import moment from "moment";

const OrderDetail = () => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [bookingDetails, setBookingDetails] = useState();
  const { id } = useParams();

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await VIEW_BOOKING(id);
    checkResponse({ res, setData: setBookingDetails, setLoader });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const data = bookingDetails || {};
  console.log(data, "data====<>");

  const roomData = data?.roomIds && data?.roomIds[0];
  const refundPolicy = data?.hotelId?.hotelPolicies?.find(
    (policy) => policy.lable === "Refund"
  );
  return (
    <>
      {loader && <Loader />}
      <section className="detail position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Button
                  onClick={() => navigate(-1)}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#fff"
                      stroke="#1E232C"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Button>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageBooking.detail.title")}
                </h4>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <label className="form-label m-0 pb-2 ps-2 fw-bold text-muted">
                {t("manageBooking.detail.bookingDetails")}
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}  
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.bookingId")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.bookingId}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.bookingType")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.bookingType}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.cost")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      ${data?.finalPrice}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.status")}</p>
                    <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                      {data?.bookingStatus}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.checkIn")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {moment(data?.checkInDate).format("LLL")}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.checkOut")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {moment(data?.checkOutDate).format("LLL")}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <label className="form-label m-0 pb-2 ps-2 fw-bold text-muted">
                {t("manageBooking.detail.userDetail")}
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.name")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.customerId?.first_name}{" "}
                      {data?.customerId?.last_name}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.email")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.customerId?.email}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.phone")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.customerId?.mobileNumber}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.address")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.customerId?.address}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>


            <Col lg="6" className="my-2">
              <label className="form-label m-0 pb-2 ps-2 fw-bold text-muted">
                {t("manageBooking.detail.hotelDetails")}
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.hotelName")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.hotelId?.hotelName}
                    </p>
                  </li>
                 
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.address")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.hotelId?.address}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>




            <Col lg="6" className="my-2">
              <label className="form-label m-0 pb-2 ps-2 fw-bold text-muted">
                {t("manageBooking.detail.roomAndRefundPolicy")}
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.roomNo")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {roomData?.roomNumber}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.maxOccupancy")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {roomData?.maxOccupancy}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.checkInHour")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.hotelId?.checkInTime}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.checkOutHour")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.hotelId?.checkOutTime}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.refundType")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {refundPolicy?.title || t("common.na")}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.cutoffHours")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {data?.hotelId?.cancellationCutoffHours
                        ? `${data.hotelId.cancellationCutoffHours} ${t("manageBooking.detail.hours")}`
                        : t("common.na")}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold w-25">{t("manageBooking.detail.description")}</p>
                    <p className="m-0 fw-sbold text-muted w-75">
                      {refundPolicy?.text || t("common.na")}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default OrderDetail;
